import { useGetMe } from 'Shared/hooks/api';
import { useTokenStore } from 'Shared/hooks/useTokenStore';
import { Analytics } from 'Shared/utils/client';
import { LINK } from '@constants';
import { Icon, Point, Row, Spinner, Typography } from '@viewup/ui';
import { EmptyViewingMoneyModal } from 'app/_components/EmptyViewingMoneyModal';
import { useGlobalModalStore } from 'app/_hook';
import { useGetEarnedPoints } from 'app/viewing-money/_features/api';
import { usePathname, useRouter } from 'next/navigation';

export const HeaderPoint = () => {
  const router = useRouter();
  const pathname = usePathname();
  const { accessToken } = useTokenStore();
  const { data: getUserInfo, isPending } = useGetMe();
  const me = getUserInfo?.data;
  const isMePending = !!accessToken && isPending;
  const { data: earnedPoints } = useGetEarnedPoints({ options: { enabled: !!accessToken } });
  // 로그아웃 후에도 캐시에 값이 남을 수 있어 토큰 유무로 분기한다
  const exchangeablePoint = accessToken ? earnedPoints?.data.exchangeablePoint || 0 : 0;

  const { getValue } = useGlobalModalStore();
  const { setConfirmModal, setAlertModal } = getValue('actions');

  return (
    <Row
      alignItems='center'
      css={{
        cursor: 'pointer',
      }}
      onClick={() => {
        if (!accessToken) {
          setConfirmModal({
            content: `본 서비스는 회원만 이용이 가능해요.\n로그인할까요?`,
            onClickFillButton: () => {
              router.replace(LINK.LOGIN);
            },
          });
          return;
        }

        Analytics.getInstance().track('MAIN_HEADER_VIEWING_MONEY');
        if (!me) return;
        EmptyViewingMoneyModal(me.totalPoint, router, setAlertModal);
      }}
    >
      <Icon color='icon.point' size='XS' source={Point} />
      <Typography color='text.primary' fontType='body2.medium'>
        {isMePending ? <HeaderPointSpinner /> : exchangeablePoint.toLocaleString('ko-KR')}
      </Typography>
    </Row>
  );
};

const HeaderPointSpinner = () => {
  return (
    <span style={{ display: 'inline-flex', minWidth: 32 }}>
      <Spinner size='S' variant='threeDot' />
    </span>
  );
};
